import {mapGetters} from 'vuex';

export default {
    name: 'searchGeoContent',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp', 'getGeoPath', 'getGeoDisplayText']),
        geoName() {
            return this.msp.geo?.geoName || '';
        },
        getSchoolsLink() {
            return this.glb.geo.geoType === 'STATE' ? `${this.glb.appUrl}${this.getGeoPath || ''}schools/` : `${this.glb.appUrl}schools/${this.getGeoPath || ''}`;
        },
    },
}
